import React, { useState, useEffect } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Menu, X, LogOut, Moon, Sun } from 'lucide-react';
import { TOKEN_KEY, USER_ROLE_KEY } from '../../utils/constants';
import { useColorMode } from '../../context/ColorModeContext';
import './ParentNavbar.css';
import logo from '../../assets/images/logo.jpeg';

const ParentNavbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { mode, toggleMode } = useColorMode();
  const navigate = useNavigate();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const toggleMenu = () => setIsOpen(!isOpen);

  const handleLogout = () => {
    if (window.confirm('Are you sure you want to logout?')) {
      localStorage.removeItem(TOKEN_KEY);
      localStorage.removeItem(USER_ROLE_KEY);
      navigate('/');
    }
  };

  return (
    <nav className={`parent-navbar ${scrolled ? 'scrolled' : ''}`}>
      <div className="navbar-container">
        <Link to="/parent-dashboard" className="navbar-logo">
          <img src={logo} alt="ZapTick AI" className="logo-image" />
          <span className="logo-text">ZapTick AI</span>
        </Link>

        {/* Desktop Actions */}
        <div className="navbar-desktop-actions">
          <button
            className="theme-toggle-parent"
            onClick={toggleMode}
            aria-label={mode === 'dark' ? 'Switch to light mode' : 'Switch to dark mode'}
            title={mode === 'dark' ? 'Light mode' : 'Dark mode'}
          >
            {mode === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
          </button>
          <button className="logout-button-modern" onClick={handleLogout}>
            <LogOut size={18} style={{ marginRight: '6px' }} />
            Logout
          </button>
        </div>

        {/* Mobile Toggle */}
        <button className="mobile-toggle" onClick={toggleMenu} aria-label="Toggle menu">
          {isOpen ? <X size={24} /> : <Menu size={24} />}
        </button>

        {/* Mobile Menu */}
        <div className={`mobile-menu ${isOpen ? 'open' : ''}`}>
          <div className="mobile-menu-content">
            <div className="mobile-divider"></div>
            <button
              className="mobile-theme-toggle"
              onClick={() => {
                toggleMode();
                toggleMenu();
              }}
            >
              {mode === 'dark' ? <Sun size={20} /> : <Moon size={20} />}
              {mode === 'dark' ? 'Light mode' : 'Dark mode'}
            </button>
            <button className="mobile-logout" onClick={() => { toggleMenu(); handleLogout(); }}>
              <LogOut size={20} />
              Logout
            </button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default ParentNavbar;
